// User Roles
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["DOCTOR"] = "DOCTOR";
    UserRole["DRUGSTORE_MANAGER"] = "DRUGSTORE_MANAGER";
    UserRole["DRUGSTORE_EMPLOYEE"] = "DRUGSTORE_EMPLOYEE";
    UserRole["CUSTOMER"] = "CUSTOMER";
    UserRole["PHARMACY_MANAGER"] = "PHARMACY_MANAGER";
    UserRole["PHARMACY_EMPLOYEE"] = "PHARMACY_EMPLOYEE";
    UserRole["CONSULTANT"] = "CONSULTANT";
})(UserRole || (UserRole = {}));
// Order/Prescription Status
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderStatus["READY_FOR_PICKUP"] = "READY_FOR_PICKUP";
    OrderStatus["COMPLETED"] = "COMPLETED";
})(OrderStatus || (OrderStatus = {}));
// Integration Types for Pharmacy Chains
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["CENTRAL"] = "CENTRAL";
    IntegrationType["DISTRIBUTED"] = "DISTRIBUTED";
})(IntegrationType || (IntegrationType = {}));
//# sourceMappingURL=index.js.map